import { search, post, get, put, remove } from '../../helpers/api';

export const COUNCIL_DECISION_SERVICE_URI = '/taxonomies';
export const COUNCIL_DECISION_BASE_URI = '/api/v1/council-decision';

export const searchCouncilDecisions = async (data) =>
  search(
    `${COUNCIL_DECISION_SERVICE_URI}${COUNCIL_DECISION_BASE_URI}/search`,
    data,
  );

export const getCouncilDecisionById = async (id) =>
  get(`${COUNCIL_DECISION_SERVICE_URI}${COUNCIL_DECISION_BASE_URI}/${id}`);

export const createCouncilDecision = async (councilDecision) =>
  post(
    `${COUNCIL_DECISION_SERVICE_URI}${COUNCIL_DECISION_BASE_URI}`,
    councilDecision,
  );

export const updateCouncilDecision = async (councilDecision) =>
  put(
    `${COUNCIL_DECISION_SERVICE_URI}${COUNCIL_DECISION_BASE_URI}/${councilDecision.id}`,
    councilDecision,
  );

export const deleteCouncilDecision = async (councilDecision) =>
  remove(
    `${COUNCIL_DECISION_SERVICE_URI}${COUNCIL_DECISION_BASE_URI}/${councilDecision.id}`,
  );
